import { eqjToEcl } from "./positions";
import * as Astronomy from "astronomy-engine";
import type { Vec3 } from "./coords";

/**
 * 银道坐标基向量（Hipparcos 的 ICRS→银道矩阵的三行，赤道 J2000 坐标）：
 * x = 银心方向，y = 银经 90° 方向，z = 银北极。
 */
const GAL_ROWS_EQJ: [number, number, number][] = [
  [-0.0548755604162154, -0.8734370902348850, -0.4838350155487132],
  [+0.4941094278755837, -0.4448296299600112, +0.7469822444972189],
  [-0.8676661490190047, -0.1980763734312015, +0.4559837761750669],
];
const asEcl = (r: [number, number, number]): Vec3 => eqjToEcl(new Astronomy.Vector(r[0], r[1], r[2], new Astronomy.AstroTime(0)));

/** 银道基向量（黄道 J2000 坐标）。 */
export const GALACTIC_BASIS_ECL: { x: Vec3; y: Vec3; z: Vec3 } = {
  x: asEcl(GAL_ROWS_EQJ[0]!), y: asEcl(GAL_ROWS_EQJ[1]!), z: asEcl(GAL_ROWS_EQJ[2]!),
};

/** 黄道 J2000 方向 → 银经、银纬（度；银经 0–360）。 */
export function eclipticToGalactic(v: Vec3): { l: number; b: number } {
  const { x, y, z } = GALACTIC_BASIS_ECL;
  const gx = v.x * x.x + v.y * x.y + v.z * x.z, gy = v.x * y.x + v.y * y.y + v.z * y.z, gz = v.x * z.x + v.y * z.y + v.z * z.z;
  const n = Math.hypot(gx, gy, gz);
  return { l: (((Math.atan2(gy, gx) * 180) / Math.PI) + 360) % 360, b: (Math.asin(gz / n) * 180) / Math.PI };
}
